import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useGlobalModal } from "../../components/Contexts/GlobalModalContext";

type ConfirmSetAvailableModalProps = {
  machineName: string
  handleSetAvailable: () => void
}

const ConfirmSetAvailableModal: React.FC<ConfirmSetAvailableModalProps> = ({ machineName, handleSetAvailable }) => {
  const { hideModal } = useGlobalModal();

  return (
    <form>
      <div>
        <h2 className="border-b border-theme-border font-semibold pb-2 mb-8 text-[1.6rem] text-theme-text">
          Mark {machineName} as "Available"?
          <FontAwesomeIcon icon={faSpinner} spin
            className={`text-theme-text text-sm transition ease-out mb-2 ml-1`} />
        </h2>
        <p className="text-theme-text">The 'time available' will be marked as now.</p>
      </div>
      <div className=" flex justify-end gap-2 mt-12">
        <button
          type="button"
          onClick={hideModal}
          className="px-4 py-2 cursor-pointer bg-theme-text-muted text-theme-text hover:bg-theme-text-muted-hover hover:text-theme-text-hover transition ease-out rounded-sm border-none"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={handleSetAvailable}
          className="px-4 py-2 rounded cursor-pointer bg-theme-success text-white hover:bg-theme-success-hover transition ease-out rounded-sm border-none"
        >
          Confirm
        </button>
      </div>
    </form>
  )
}

export default ConfirmSetAvailableModal